module.exports = __webpack_public_path__ + "img/CS-UL-II-Info.d18ed5d8.jpg";